import { useMomentItemsByMoment } from 'gql/api/queries/moment-items-by-moment.generated';
import { mapMomentItemsToNftItems as mapMomentItemsToMomentInventory } from 'utils/story/story';

export async function getMomentInventory(variables: { momentId: number }) {
  const getMomentItemsByMoment = useMomentItemsByMoment.fetcher({
    momentId: variables.momentId,
    perPage: 100,
  });

  const res = await getMomentItemsByMoment();

  return mapMomentItemsToMomentInventory(res.moment.items);
}
